import React from 'react';
import { Users } from 'lucide-react';
import { getDomainConfig } from '../../utils/helpers';
import { API_BASE_URL } from '../../utils/constants';

const ClassCard = ({
    classItem,
    isEnrolled,
    handleClassSelect,
    handleEnroll,
    handleDrop
}) => {
    const config = getDomainConfig(classItem.name);

    return (
        <div
            className="group bg-white rounded-3xl shadow-xl overflow-hidden transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl border border-gray-100 flex flex-col"
        >
            {/* Image + Gradient + Icon */}
            <div className="relative h-64 overflow-hidden">
                <img
                    src={config.image}
                    alt={classItem.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Gradient Overlay */}
                <div
                    className={`absolute inset-0 bg-gradient-to-t ${config.gradient} opacity-20 group-hover:opacity-30 transition-opacity duration-300`} />
                {/* Icon Badge */}
                <div className="absolute top-4 right-4">
                    <div
                        className={`w-12 h-12 bg-gradient-to-r ${config.gradient} rounded-full flex items-center justify-center shadow-lg`}>
                        {config.icon}
                    </div>
                </div>
                {/* Enrolled or Available Badge */}
                <span
                    className={`absolute top-4 left-4 ${isEnrolled
                        ? 'bg-green-100 text-green-700'
                        : 'bg-blue-100 text-blue-700'
                        } text-xs font-semibold px-4 py-1 rounded-full shadow-lg`}
                >
                    {isEnrolled ? 'Enrolled' : 'Available'}
                </span>
            </div>

            {/* Card Content */}
            <div className="p-6 flex-1 flex flex-col">
                {/* Name */}
                <div className="mb-3">
                    <h3 className="text-xl font-bold text-[#1D3469] mb-2 leading-tight">
                        {classItem.name}
                    </h3>
                    {/* Pills */}
                    <div className="flex gap-2 mb-2 flex-wrap">
                        <span
                            className="px-3 py-1 bg-gradient-to-r from-orange-100 to-red-100 text-[#F17C45] font-semibold rounded-full text-xs border border-orange-200">
                            Level: {classItem.level || 1}
                        </span>
                        <span
                            className="px-3 py-1 bg-gradient-to-r from-blue-100 to-indigo-100 text-[#1D3469] font-semibold rounded-full text-xs border border-blue-200">
                            Grade: {classItem.grade || 1}
                        </span>
                        {classItem.section && (
                            <span
                                className="px-3 py-1 bg-gradient-to-r from-purple-100 to-indigo-100 text-purple-700 font-semibold rounded-full text-xs border border-purple-200">
                                Section: {classItem.section}
                            </span>
                        )}
                        <span
                            className="px-3 py-1 bg-gradient-to-r from-green-100 to-green-200 text-green-700 font-semibold rounded-full text-xs border border-green-200">
                            Duration: {classItem.duration || "12 weeks"}
                        </span>
                    </div>
                </div>
                {/* Description */}
                <p className="text-gray-600 mb-5 text-sm leading-relaxed font-medium line-clamp-2">
                    {classItem.description}
                </p>

                {/* Stats Row (Instructor) */}
                <div className="grid grid-cols-1 gap-4 mb-5">
                    <div className="text-center">
                        <div
                            className="w-12 h-12 bg-gradient-to-r from-blue-100 to-blue-200 rounded-xl flex items-center justify-center mb-2 mx-auto group-hover:scale-110 transition-transform duration-300">

                            {classItem.teacher.profile_picture_url ? (
                                <img
                                    src={API_BASE_URL + classItem.teacher.profile_picture_url}
                                    alt={classItem.teacher.name}
                                    className="h-10 w-10 rounded-full object-cover border-2 border-[#F7D1B6]"
                                />
                            ) : (
                                <Users className="w-6 h-6 text-blue-600" />
                            )}
                        </div>
                        <div className="text-xs text-gray-500 font-medium mb-1">Instructor</div>


                        <div className="text-base font-bold text-[#1D3469]">
                            {classItem.teacher?.name || "Instructor"}
                        </div>


                    </div>
                </div>

                {/* Action Row */}
                <div className="flex flex-col sm:flex-row gap-3 mt-auto">
                    <button
                        onClick={() => handleClassSelect(classItem)}
                        className="w-full sm:w-auto flex-1 bg-[#D67C2C] hover:bg-[#e06b35] text-white font-bold py-2.5 px-4 rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-orange-200 text-sm"
                    >
                        View Details
                    </button>
                    {/*{isEnrolled ? (*/}
                    {/*    <button*/}
                    {/*        onClick={() => handleDrop(classItem)}*/}
                    {/*        className="w-full sm:w-auto flex-1 border border-red-200 bg-red-50 text-red-700 font-bold py-2.5 px-4 rounded-xl transition-all duration-300 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-200 text-sm"*/}
                    {/*    >*/}
                    {/*        Leave*/}
                    {/*    </button>*/}
                    {/*) : (*/}
                    {/*    <button*/}
                    {/*        onClick={() => handleEnroll(classItem)}*/}
                    {/*        className="w-full sm:w-auto flex-1 border border-blue-200 bg-blue-50 text-blue-700 font-bold py-2.5 px-4 rounded-xl transition-all duration-300 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-200 text-sm"*/}
                    {/*    >*/}
                    {/*        Join*/}
                    {/*    </button>*/}
                    {/*)}*/}
                </div>
            </div>
        </div>
    );
};

export default ClassCard;
